var map = {
	"./tqicon-1.svg": 1413,
	"./tqicon-10.svg": 1414,
	"./tqicon-11.svg": 1415,
	"./tqicon-2.svg": 1416,
	"./tqicon-3.svg": 1417,
	"./tqicon-4.svg": 1418,
	"./tqicon-5.svg": 1419,
	"./tqicon-6.svg": 1420,
	"./tqicon-7.svg": 1421,
	"./tqicon-8.svg": 1422,
	"./tqicon-9.svg": 1423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 240;